// Matches the filter row's inputs and buttons (2.125rem); the SPA select theme defaults taller.
const CONTROL_HEIGHT = '2.125rem';

const filterSelectStyles = {
  control: (base: object) => ({ ...base, height: CONTROL_HEIGHT, minHeight: CONTROL_HEIGHT }),
  valueContainer: (base: object) => ({ ...base, padding: '0 0.5rem' }),
};

export default filterSelectStyles;
